import { isValidSessionId, parseInvitationRoute } from "../../protocol";
import type { TransferInputFile, TransferLimits } from "../../packaging";
import { ReceiverTransfer } from "./ReceiverTransfer";
import { SenderTransfer } from "./SenderTransfer";
import "./transfer.css";

export interface QrTransferWorkspaceProps {
  initialFiles?: TransferInputFile[];
  route?: "send" | "receive";
  sessionId?: string;
  resumeSessionId?: string;
  invitationRoute?: string;
  baseUrl?: string;
  limits?: Partial<TransferLimits>;
}

function resolveReceiverSession(
  sessionId: string | undefined,
  invitationRoute: string | undefined,
): string | undefined {
  if (sessionId !== undefined && isValidSessionId(sessionId)) {
    return sessionId;
  }

  const route =
    invitationRoute ??
    (typeof window === "undefined" ? undefined : window.location.hash);
  if (route === undefined) {
    return undefined;
  }
  const parsed = parseInvitationRoute(route);
  return parsed.ok ? parsed.sessionId : undefined;
}

export function QrTransferWorkspace({
  initialFiles,
  route = "send",
  sessionId,
  resumeSessionId,
  invitationRoute,
  baseUrl,
  limits,
}: QrTransferWorkspaceProps) {
  if (route === "receive") {
    const receiverSessionId = resolveReceiverSession(sessionId, invitationRoute);
    return (
      <div className="qr-transfer">
        <ReceiverTransfer
          key={`receiver:${receiverSessionId ?? "invalid"}`}
          {...(limits === undefined ? {} : { limits })}
          {...(receiverSessionId === undefined ? {} : { sessionId: receiverSessionId })}
        />
      </div>
    );
  }

  return (
    <div className="qr-transfer">
      <SenderTransfer
        key={`sender:${resumeSessionId ?? sessionId ?? "new"}`}
        {...(baseUrl === undefined ? {} : { baseUrl })}
        {...(initialFiles === undefined ? {} : { initialFiles })}
        {...(limits === undefined ? {} : { limits })}
        {...(resumeSessionId === undefined ? {} : { resumeSessionId })}
        {...(sessionId === undefined ? {} : { sessionId })}
      />
    </div>
  );
}
